import { flatten, pick } from "lodash";
import { Injectable } from "@angular/core";
import { Http, Response } from "@angular/http";
import { Observable } from "rxjs";

import { BASE_CONSTANTS, BASE_URLS, ITCIEnvVars } from "@tci/common";

@Injectable()
export class NgEnvVarsService {

    private static allEnvVars$: Observable<ITCIEnvVars<any>>;
    private static allEnvVars: ITCIEnvVars<any> = null;
    private static instance: NgEnvVarsService = null;

    public static getInstance(http: Http): NgEnvVarsService {
        if (!NgEnvVarsService.instance) {
            NgEnvVarsService.instance = new NgEnvVarsService(http);
        }
        return NgEnvVarsService.instance;
    }

    private constructor(
        private http: Http
    ) { }

    public getEnvVar(...envVarNames: string[]): Observable<ITCIEnvVars<any>> {
        const varNames = flatten(envVarNames);
        // console.log("NgEnvVarsService.allEnvVars is ", NgEnvVarsService.allEnvVars);

        if (NgEnvVarsService.allEnvVars) {
            return Observable.of(pick(NgEnvVarsService.allEnvVars, varNames));
        } else {
            return this
                .getAllEnvVars()
                .map((allEnvVars: ITCIEnvVars<any>): ITCIEnvVars<any> => {
                    return pick(allEnvVars, varNames);
                });
        }
    }

    private getAllEnvVars(): Observable<ITCIEnvVars<any>> {
        // console.log("NgEnvVarsService.allEnvVars$ is ", NgEnvVarsService.allEnvVars$);
        return NgEnvVarsService.allEnvVars$ ||
            (
                NgEnvVarsService.allEnvVars$ = this
                    .http
                    .get(BASE_URLS.WEBSERVER + BASE_CONSTANTS.ENV_VARS)
                    .map((res: Response) => {
                        return NgEnvVarsService.allEnvVars = res.json() || {};
                    })
                    .share()
            );
    }
}
